import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface YpfIntegrationModalSectionProps {
    className?: string;
}

const YpfIntegrationModalSection: FC<PropsWithChildren<YpfIntegrationModalSectionProps>> = ({
    children,
    className,
}) => {
    return <div className={twMerge('flex flex-col w-full border-t border-[#455A64] py-4', className)}>{children}</div>;
};

export default YpfIntegrationModalSection;
